__turbopack_context__.v({
  "hero__picture_video": "styles-module-scss-module__k9jLua__hero__picture_video",
});
